import { MutationCache, QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    async onSuccess(_data, _variables, _context, mutation) {
      if (mutation.options.mutationKey) {
        await queryClient.invalidateQueries({
          queryKey: mutation.options.mutationKey,
        });
      }
    },
  }),
});

export default queryClient;
